"use client";

import { useEffect, useState } from "react";

const DEFAULT_THRESHOLD = 320;

export function useNearFooter(
  scrollY: number,
  threshold = DEFAULT_THRESHOLD
): boolean {
  const [nearFooter, setNearFooter] = useState(false);

  useEffect(() => {
    const update = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const viewportBottom = scrollY + window.innerHeight;
      setNearFooter(viewportBottom >= scrollHeight - threshold);
    };

    update();
    window.addEventListener("resize", update, { passive: true });
    return () => window.removeEventListener("resize", update);
  }, [scrollY, threshold]);

  return nearFooter;
}
